import { CSSProperties, ReactNode } from 'react';
import cn from 'classnames';
import BaseModal from '@/components/modal/lib/BaseModal';
import Text from '@/components/common/Text/Text';

import './SimpleModal.style.scss';

type SimpleModalProps = {
  className?: string;

  onClose: () => void;

  title?: string;

  children?: ReactNode;

  contentStyle?: CSSProperties;
};

/** Renders a simple modal with a title and body text as children */
function SimpleModal(props: SimpleModalProps) {
  const { className = '', onClose, title, children, contentStyle = {} } = props;

  return (
    <BaseModal
      className={cn('SimpleModal', className)}
      onClose={onClose}
    >
      <div
        className='SimpleModal-content'
        style={contentStyle}
      >
        {title && (
          <Text
            className='SimpleModal-title'
            variant='title-xl'
            italic
          >
            {title}
          </Text>
        )}
        {children}
      </div>
    </BaseModal>
  );
}

export default SimpleModal;
